// next
// icons
import directionStraightRight from '@iconify/icons-carbon/direction-straight-right';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
// @mui
import { styled } from '@mui/material/styles';
import NextLink from 'next/link';
import { ArticleProps } from 'src/@types/article';
// components
import { Iconify, TextMaxLine } from '../../components';
import Image from '../../components/NextSanityImage';
// hooks
import useResponsive from '../../hooks/useResponsive';
// routes
import Routes from '../../routes';
// utils
import { fDate } from '../../utils/formatTime';
//
import BlogPostItemMobile from './BlogPostItemMobile';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(8, 0),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(15, 0),
  },
}));

// ----------------------------------------------------------------------

type Props = {
  articles: ArticleProps[];
};

export default function LatestPosts({ articles }: Props) {
  const isDesktop = useResponsive('up', 'md');

  return (
    <RootStyle>
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent={{ xs: 'center', md: 'space-between' }}
          sx={{
            mb: { xs: 8, md: 10 },
          }}
        >
          <Typography variant="h2">Nylige artikler</Typography>

          <NextLink href={Routes.blog}>
            <Button
              endIcon={<Iconify icon={directionStraightRight} sx={{ width: 22, height: 22 }} />}
              sx={{ display: { xs: 'none', md: 'inline-flex' } }}
            >
              Se alle
            </Button>
          </NextLink>
        </Stack>

        <Box
          sx={{
            display: 'grid',
            gap: 3,
            gridTemplateColumns: {
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(4, 1fr)',
            },
          }}
        >
          {articles
            .slice(0, 4)
            .map((article) =>
              isDesktop ? (
                <PostItem key={article.slug.current} article={article} />
              ) : (
                <BlogPostItemMobile key={article.slug.current} article={article} path={Routes.blog} />
              )
            )}
        </Box>

        <Stack
          alignItems="center"
          sx={{
            mt: 8,
            display: { xs: 'flex', md: 'none' },
          }}
        >
          <NextLink href={Routes.blog}>
            <Button
              endIcon={<Iconify icon={directionStraightRight} sx={{ width: 22, height: 22 }} />}
            >
              Se alle
            </Button>
          </NextLink>
        </Stack>
      </Container>
    </RootStyle>
  );
}

// ----------------------------------------------------------------------

type PostItemProps = {
  article: ArticleProps;
};

function PostItem({ article }: PostItemProps) {
  const { title, header, date, slug } = article;

  return (
    <Stack spacing={2.5}>
      <Image src={header} alt={title} ratio="1/1" sx={{ borderRadius: 2 }} />

      <Stack spacing={1}>
        <Stack
          direction="row"
          alignItems="center"
          sx={{ typography: 'caption', color: 'text.disabled' }}
        >
          {fDate(date)}
        </Stack>

        <NextLink passHref href={Routes.post('[slug]')} as={Routes.post(slug.current)}>
          <TextMaxLine variant="h6" asLink persistent>
            {title}
          </TextMaxLine>
        </NextLink>
      </Stack>

      {/* <Stack spacing={1} direction="row" alignItems="center">
        <Avatar src={author.picture} sx={{ width: 32, height: 32 }} />
        <Typography variant="body2">{author.name}</Typography>
      </Stack> */}
    </Stack>
  );
}
